import { render, staticRenderFns } from "./DropPosition.vue?vue&type=template&id=6fa31f5a&"
import script from "./DropPosition.vue?vue&type=script&lang=js&"
export * from "./DropPosition.vue?vue&type=script&lang=js&"
import style0 from "./DropPosition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports